// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"91":"21f3a061","196":"1446fa5b","344":"4aa07c4f","389":"f120ec7c","605":"317ba660","606":"ed958619","962":"560ea2c8"}[chunkId] + ".chunk.css";
};